// Firebase Configuration - giroexpress-bancked-taza (NUEVO PROYECTO)
// Auth + Firestore
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// authDomain es lo que ve el usuario en el popup de Google OAuth.
// En producción, el .env del deploy DEBE definir
//   REACT_APP_FIREBASE_AUTH_DOMAIN=ruletagiroexpress.com
// (este dominio debe estar autorizado en Firebase Console → Authentication
// → Settings → Authorized domains, con __/auth/handler accesible).
// Si el .env no lo define, usamos el dominio nativo del proyecto Firebase
// como fallback seguro (no rompe el login en preview).
const _envAuthDomain = (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "").trim();
const _isPlaceholder =
  !_envAuthDomain ||
  _envAuthDomain.toUpperCase().includes("YOUR_PROJECT") ||
  _envAuthDomain.toUpperCase().includes("YOUR_FIREBASE");
const _authDomain = _isPlaceholder
  ? "giroexpress-bancked-taza.firebaseapp.com"
  : _envAuthDomain;

const firebaseConfig = {
  apiKey: "AIzaSyBmpW9u7vV8_SnN8sdN_ygRynJKeA_QdBE",
  authDomain: _authDomain,
  projectId: "giroexpress-bancked-taza",
  storageBucket: "giroexpress-bancked-taza.firebasestorage.app",
  messagingSenderId: "1029883643913",
  appId: "1:1029883643913:web:f1b9a30be188823147d0d8",
  measurementId: "G-D85B16N2VE",
};

// Detecta Preview Emergent (solo informativo; ya NO desactiva Auth)
const isPreview =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("preview.emergentagent.com") ||
    window.location.hostname.includes("emergent.sh"));

// Log de configuración al iniciar
console.log("🔧 FIREBASE CONFIG:", {
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  currentHost: typeof window !== "undefined" ? window.location.host : "SSR",
  isPreview,
});

const app = initializeApp(firebaseConfig);

// ✅ Verificación del proyecto activo
console.log("🔥 FIREBASE APP INICIALIZADO:", {
  "app.options.projectId": app.options.projectId,
  "esperado": "giroexpress-bancked-taza",
  "match": app.options.projectId === "giroexpress-bancked-taza"
});

export const db = getFirestore(app);

// Auth inicializado siempre (Google real en cualquier entorno).
// El login DEV (dev-preview-user) solo se activa explícitamente via
// REACT_APP_ENABLE_DEV_LOGIN=true (ver firebaseAuth.js).
export const auth = getAuth(app);

export { firebaseConfig };
export default app;